import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { randomProvidersActionByKeywordOrAddress, stateIsLoaded } from '@guryou/redux';

const BookSection = () => {
  const dispatch = useDispatch();
  const randomProviders = useSelector(state => state.randomProviders);

  const centers = randomProviders?.data?.response?.centers.slice(0, 6);
  const professionals = randomProviders?.data?.response?.professionals.slice(0, 4);

  useEffect(() => {
    dispatch(randomProvidersActionByKeywordOrAddress());
  }, [dispatch]);

  if (!stateIsLoaded) {
    return null;
  }

  return (
    <section class="bg-white">
      <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-32 lg:px-6">
        <div class="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
          <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">Book</h2>
          <p class="font-light text-gray-500 lg:mb-16 sm:text-xl">
            Prenota: utilizza il nostro servizio di ricerca per esplorare, scegliere e prenotare le migliori esperienze wellness, su misura per te.
          </p>
        </div>
        <div class="grid gap-8 mb-6 lg:mb-16 sm:grid-cols-2 md:grid-cols-3">
          {centers?.map(card => (
            <div class="max-w-sm flex flex-col bg-gray-50 rounded-lg shadow" key={card.id}>
              <a href="#">
                <img class="w-full h-64 rounded-lg sm:rounded-none sm:rounded-l-lg  object-cover" src={card.images[0].medium} alt={card.name} />
              </a>

              <div class="p-5 w-full flex flex-col">
                <h3 class="text-xl font-bold tracking-tight text-gray-900">
                  <a href="#">{card.name}</a>
                </h3>
                <span class="text-gray-500 line-clamp-1">{card?.categories.map(cat => cat.name).join(', ')}</span>
                <p class="mt-3 mb-4 font-light text-gray-500 line-clamp-4 break-all">{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <section class="bg-gray-50">
        <div class="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-32 lg:px-6">
          <div class="mx-auto mb-8 max-w-screen-sm lg:mb-16">
            <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">I nostri professionisti</h2>
            <p class="font-light text-gray-500 sm:text-xl">
              Scopri i migliori professionisti del benessere e della cura personale in un unico luogo!
            </p>
          </div>
          <div class="grid gap-8 lg:gap-16 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {professionals?.map(card => (
              <div class="text-center text-gray-500" key={card.id}>
                <img class="mx-auto mb-4 w-36 h-36 rounded-full" src={card.images[0].medium} alt={card.name} />
                <h3 class="mb-1 text-2xl font-bold tracking-tight text-gray-900">
                  <a href="#">{card.name}</a>
                </h3>
                <p class="font-light text-gray-500 line-clamp-1">{card?.categories.map(cat => cat.name).join(', ')}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </section>
  );
};
export default BookSection;
